import { lazy } from 'react';
const DeliveryChallan = lazy(() => import('@custom/ComputerRental/Delivery/DeliveryChallan'));
const CustomerReport = lazy(() => import('@custom/ComputerRental/customer_report/CustomerReport'));
const ProductReport = lazy(() => import('@custom/ComputerRental/customer_report/ProductReport'));
const DeliveryChallanList = lazy(() => import('@custom/ComputerRental/Delivery/DeliveryChallanList'));
const QuotationListView = lazy(() => import('@custom/ComputerRental/Quotation/QuotationListView'));
const CreateQuotation = lazy(() => import('@custom/ComputerRental/Quotation/CreateQuotation'));

const ProductInvocing = lazy(() => import('@custom/ComputerRental/Invoice/views/ProductInvocing'));
const DashboardDetails = lazy(() => import('@custom/ComputerRental/Dashboard/DashboardDetails'));
const PendingBillingReport = lazy(() => import('@custom/ComputerRental/customer_report/PendingBillingReport'));
const ChargersListView = lazy(() => import('@custom/ComputerRental/chargers/views/ChargersListView'));
const ProductsView = lazy(() => import('@custom/ComputerRental/products/views/ProductsView'));
const CustomerListView = lazy(() => import('@custom/ComputerRental/customer/views/CustomerListView'));
const InvoiceListView = lazy(() => import('@custom/ComputerRental/Invoice/views/InvoiceListView'));
const InvoicePreview = lazy(() => import('@custom/ComputerRental/Invoice/views/invoicePreview'));
// ONLY protected, core system routes go here
const computerRentalRoutes = [
  {
    path: '/delivery/create',
    skipPermission: true,
    element: <DeliveryChallan />,
  },
  {
    path: '/delivery/edit/:record_id',
    skipPermission: true,
    element: <DeliveryChallan />
  },
  {
    path: '/deliveries',
    element: <DeliveryChallanList />,
   
  },
    {
    path: '/quotations',
    element: <QuotationListView />
  },
    {
    path: '/quotation/create',
    skipPermission: true,
    element: <CreateQuotation />
  },
  {
    path: '/quotation/edit/:record_id',
    skipPermission: true,
    element: <CreateQuotation />
  },
  {
    path: '/CustomerReport',
    element: <CustomerReport />
  },
  {
    path: '/customer-report/:record_id',
    skipPermission: true,
    element: <CustomerReport />
  },
  {
    path: '/product-report',
    skipPermission: true,
    element: <ProductReport />
  },
   {
    path: '/product-report/:record_id',
    skipPermission: true,
    element: <ProductReport />
  },
  
  {
    path: '/invoice-calculator',
    skipPermission: true,
    element: <ProductInvocing />
  },
  {
    path: '/dashboard',
    skipPermission: true,
    element: <DashboardDetails />
  },
  {
    path: '/pending-billing',
    skipPermission: true,
    element: <PendingBillingReport />
  },
  {
    path: '/chargeserialnumber',
    element: <ChargersListView />
  },
   {
    path: '/products',
    element: <ProductsView />
  },
  {
    path: '/products/:product_id',
    skipPermission: true,
    element: <ProductsView />
  },
  {
    path: '/customer',
    element: <CustomerListView />
  },
  {
    path: '/invoices',
    element: <InvoiceListView />
  },
  {
    path: '/invoice/edit/:record_id',
    skipPermission: true,
    element: <InvoicePreview />
  },
];
export default computerRentalRoutes;